import { render, staticRenderFns } from "./VipPurchasePopup.vue?vue&type=template&id=3d125dc7&scoped=true"
import script from "./VipPurchasePopup.vue?vue&type=script&lang=js"
export * from "./VipPurchasePopup.vue?vue&type=script&lang=js"
import style0 from "./VipPurchasePopup.vue?vue&type=style&index=0&id=3d125dc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d125dc7",
  null
  
)

export default component.exports